import * as React from "react";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CreateCaseDialog from "../../../components/dialogs/createCase";
import SetPublishedLinkDialog from "src/components/dialogs/setPublishedLinkDialog";

interface Props {
  value: string;
  onChange: (value: string) => void;
}
interface State {}
export default class SetPublishedLinkButton extends React.Component<
  Props,
  State
> {
  state = {
    open: false
  };
  onClose = value => {
    this.setState({ open: false });
  };
  onChange = value => {
    this.setState({ open: false });
    this.props.onChange(value);
  };
  render() {
    return (
      <React.Fragment>
        <SetPublishedLinkDialog
          value={this.props.value}
          open={this.state.open}
          onChange={this.onChange}
          onClose={this.onClose}
        />
        <Button
          variant="outlined"
          style={{}}
          onClick={() => {
            this.setState({ open: true });
          }}
        >
          Set Published Link
        </Button>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/cases/components/setPublishedLinkButton.tsx